import useAgentData from '~/client/hooks/useAgentData';
import DesktopFirstRow from './DesktopFirstRow';
import MobileFirstRow from './MobileFirstRow';

type Props = {
  hasFilters: boolean;
  pageSection: PageSection;
  isGridVisible: boolean;
  pageTitle?: string;
  pageSubTitle?: string;
  providerName?: string;
  menuItem?: string;
  isLiveRtp?: boolean;
  theme?: string;
  onShowGridClick: () => void;
  isBombayclubGamesPage?: boolean;
};

const FirstRow: FC<Props> = ({
  pageTitle,
  pageSubTitle,
  providerName,
  hasFilters,
  pageSection,
  menuItem,
  isLiveRtp,
  theme,
  isGridVisible,
  onShowGridClick,
  isBombayclubGamesPage,
}) => {
  const { isMobile } = useAgentData();
  if (isMobile) {
    return (
      <MobileFirstRow
        menuItem={menuItem}
        isLiveRtp={isLiveRtp}
        providerName={providerName}
        pageTitle={pageTitle}
        pageSection={pageSection}
        hasFilters={hasFilters}
        isGridVisible={isGridVisible}
        onShowGridClick={onShowGridClick}
        pageSubTitle={pageSubTitle}
      />
    );
  }

  return (
    <DesktopFirstRow
      hasFilters={hasFilters}
      pageSection={pageSection}
      pageTitle={pageTitle}
      providerName={providerName}
      menuItem={menuItem}
      isLiveRtp={isLiveRtp}
      theme={theme}
      isProviderFilterVisible={!isBombayclubGamesPage}
      isCategoryFilterVisible={!isBombayclubGamesPage}
      pageSubTitle={pageSubTitle}
    />
  );
};

export default FirstRow;
